import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, useIntl } from 'react-intl';
import IdleModal from './IdleModal';
import defaultMessages from '../i18n';
import { getMessages } from '../../utils';
import { IdleTimer } from '../../../neuro-ui';
import {useGuideConfig} from '../../hooks';

const Timeout = ({
  timeout,
  secTimeout,
  secTimeoutProps,
  modalProps,
  onIdle,
  ...props
}) => {
  const [active, setActive] = React.useState(false);
  const { runMode } = useGuideConfig();
  const idleTimer1 = React.useRef(null);
  const locale = useIntl().locale;
  const messages = getMessages(locale);
  const i18nMessages = {
    [locale]: { ...defaultMessages[locale], ...messages },
  };

  return (
    runMode !== 'development' && (
      <IntlProvider
        locale={locale}
        messages={i18nMessages[locale]}
        wrapRichTextChunksInFragment
      >
        <IdleTimer
          ref={idleTimer1}
          timeout={timeout}
          onIdle={() => {
            setActive(true);
          }}
          {...props}
        />
        {active && (
          <IdleModal
            onClick={() => {
              idleTimer1.current.reset();
              setActive(false);
            }}
            timeout={secTimeout}
            onIdle={onIdle}
            {...modalProps}
            {...(secTimeoutProps && { timerProps: secTimeoutProps })}
          />
        )}
      </IntlProvider>
    )
  );
};

Timeout.propTypes = {
  modalProps: PropTypes.shape({}),
  onIdle: PropTypes.func,
  secTimeout: PropTypes.number,
  secTimeoutProps: PropTypes.shape({}),
  timeout: PropTypes.number,
};

Timeout.defaultProps = {
  modalProps: {},
  onIdle: null,
  secTimeout: 30000,
  secTimeoutProps: {},
  timeout: 15000,
};

export default Timeout;
